var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { observable, action, makeObservable } from 'mobx';
import { UIOpenService } from '~/services/service.ui';
import { TabsService } from '~/services/servive.tabs';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { ModelCommunityCollectionItem } from '~/models/model.community.collection.item';
export let ServiceFileInfo = class ServiceFileInfo extends BaseSingletonService {
    fileInfoOpenService;
    tabsService;
    item;
    relatedFiles = observable.array([]);
    communityId = 17;
    constructor(fileInfoOpenService, tabsService) {
        super();
        this.fileInfoOpenService = fileInfoOpenService;
        this.tabsService = tabsService;
        makeObservable(this);
    }
    setItem(item) {
        this.item = item;
    }
    getRelatedFiles(fileId, params) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${this.communityId}/${EApiUrl.files}/${fileId}/${EApiUrl.related}`, { params })
                .then(response => {
                this.relatedFiles = plainToInstance(ModelCommunityCollectionItem, response.data?.collection || []);
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", Object)
], ServiceFileInfo.prototype, "item", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_d = typeof TImageItem !== "undefined" && TImageItem) === "function" ? _d : Object]),
    __metadata("design:returntype", void 0)
], ServiceFileInfo.prototype, "setItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], ServiceFileInfo.prototype, "getRelatedFiles", null);
ServiceFileInfo = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object, typeof (_b = typeof TabsService !== "undefined" && TabsService) === "function" ? _b : Object])
], ServiceFileInfo);
